Mobi2Go.MapsService = new Mobi2Go._class.MapsService(null);
